import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-purple-800 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">AI</span>
              </div>
              <span className="ml-2 text-xl font-bold">AI短剧工作台</span>
            </div>
            <p className="text-gray-400 mb-4">
              把灵感或初稿整理成标题、人物关系、三集推进、第1集正文和分镜草稿，方便你继续打磨、拍摄和复用。
            </p>
            <div className="flex flex-wrap gap-3 text-sm">
              <a href="https://qingxihub.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                个人主页
              </a>
              <a href="https://qingxihub.com/portfolio/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                作品集
              </a>
              <a href="https://qingxihub.com/tools/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                AI工具箱
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
              产品功能
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/create" className="text-gray-400 hover:text-white transition-colors">
                  初稿整理
                </Link>
              </li>
              <li>
                <Link to="/character-setting" className="text-gray-400 hover:text-white transition-colors">
                  角色设定
                </Link>
              </li>
              <li>
                <Link to="/storyboard" className="text-gray-400 hover:text-white transition-colors">
                  分镜设计
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-gray-400 hover:text-white transition-colors">
                  项目管理
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
              资源中心
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/resource-center" className="text-gray-400 hover:text-white transition-colors">
                  资源中心
                </Link>
              </li>
              <li>
                <Link to="/explore" className="text-gray-400 hover:text-white transition-colors">
                  短剧案例
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-gray-400 hover:text-white transition-colors">
                  我的账户
                </Link>
              </li>
              <li>
                <Link to="/analytics" className="text-gray-400 hover:text-white transition-colors">
                  数据统计
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 AI短剧工作台. 保留所有权利.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-6">
              <Link to="/resource-center" className="text-gray-400 hover:text-white text-sm transition-colors">
                资源中心
              </Link>
              <Link to="/explore" className="text-gray-400 hover:text-white text-sm transition-colors">
                短剧案例
              </Link>
              <Link to="/projects" className="text-gray-400 hover:text-white text-sm transition-colors">
                项目管理
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
